import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Text,
  View,
  TouchableOpacity,
  ScrollView,
  TextInput,
  Modal,
  Pressable,
  Image,
  ActivityIndicator,
} from "react-native";
import { CameraView, useCameraPermissions } from "expo-camera";
import Icon from "react-native-vector-icons/FontAwesome";
import { useRouter, useLocalSearchParams } from "expo-router";
import { useFocusEffect } from "@react-navigation/native";
import { useSelector, useDispatch } from "react-redux";
import { postWeightWip } from "../redux/actions/scaleactions";
import FooterComponent from "../component/footer";
import { useLanguage } from "./LanguageProvider";

export default function scancheck() {
  const [permission, requestPermission] = useCameraPermissions();
  const [scanned, setScanned] = useState(false);
  const [isCameraActive, setIsCameraActive] = useState(false);
  const [cameraFacing, setCameraFacing] = useState("front");
  const [inputText, setInputText] = useState("");
  const [modalVisible, setModalVisible] = useState(false); // ✅ เพิ่ม state สำหรับ Modal
  const [modalFailedVisible, setModalFailedVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [loadingresponse, setLoadingresponse] = useState(false);
  const router = useRouter();
  const dispatch = useDispatch();
  const { t } = useLanguage();

  const inputRef = useRef<TextInput>(null); // ✅ สร้าง ref สำหรับ TextInput
  const inputTextRef = useRef("");

  const { item: itemParams, item2: tem2Params } = useLocalSearchParams();

  const item =
    typeof itemParams === "string" ? JSON.parse(itemParams) : itemParams;

  const item2 =
    typeof tem2Params === "string" ? JSON.parse(tem2Params) : tem2Params;

    // console.log("item", item);
    // console.log("item", JSON.stringify(item, null, 2));
    // console.log("item2", JSON.stringify(item2, null, 2));

  useFocusEffect(
    useCallback(() => {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }, [])
  );

  useEffect(() => {
    if (!permission) {
      requestPermission();
    }
  }, [permission]);

  //   const handleBarCodeScanned = ({ type, data }: any) => {
  //     setScanned(true);
  //     setIsCameraActive(false);

  //     if (data === checklocation) {
  //       setModalMessage(`ข้อมูลที่สแกนตรงกับ ${checklocation}`);
  //     } else {
  //       setModalMessage("ข้อมูลที่สแกนไม่ตรง กรุณาลองอีกครั้ง!");
  //     }
  //     setModalVisible(true);
  //   };

  const handleEnterlocation = async (input: string | { data: string }) => {
    let qrData;

    // if(input != item?.qr_code){
    //   setModalMessage("ข้อมูลที่สแกนไม่ตรง กรุณาลองอีกครั้ง!");
    //   setModalFailedVisible(true);
    //   return;
    // }

    // ตรวจสอบว่าข้อมูลเป็น Object (มาจาก QR Scanner) หรือเป็น String (มาจาก TextInput)
    if (typeof input === "object" && input?.data) {
      qrData = input.data; // ถ้ามาจาก QR Code ให้ดึงค่า `data`
    } else if (typeof input === "string") {
      qrData = input.trim(); // ถ้ามาจาก TextInput ให้ใช้ค่านั้นเลย
    } else {
      console.log("ไม่พบข้อมูล");
      return;
    }
    // console.log("qrData", qrData);

    if (qrData !== item?.qrcode ) {
      setModalMessage("ข้อมูลที่สแกนไม่ตรง กรุณาลองอีกครั้ง!");
      setModalFailedVisible(true);
      return;
    }

    setScanned(true);
    setIsCameraActive(false);
    try {
      setLoadingresponse(true);
      let res = await dispatch(postWeightWip(item, qrData) as any);

      // console.log("res", res);

      if (res.success === true) {
        setLoadingresponse(false);
        setModalMessage(res.message);
        setModalVisible(true);
      } else {
        setLoadingresponse(false);
        setModalMessage(res.message);
        setModalFailedVisible(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingresponse(false);
    }
  };

  //   const handleSubmit = (text: string) => {
  //     // console.log("text", text);
  //     // if (text === checklocation) {
  //     //   setModalMessage(`ข้อมูลที่ป้อนตรงกับ ${checklocation}`);
  //     // } else {
  //     //   setModalMessage("ข้อมูลที่ป้อนไม่ตรง กรุณาลองอีกครั้ง!");
  //     // }
  //     setModalVisible(true);
  //   };

  if (!permission) {
    return (
      <Text className="text-center text-lg mt-5">
        {/* กำลังขอสิทธิ์การใช้งานกล้อง... */}
        {t("requesting_camera_permission")}
      </Text>
    );
  }

  if (!permission.granted) {
    return (
      <View className="flex-1 justify-center items-center bg-gray-100">
        <Text className="text-lg">
          {/* ไม่สามารถใช้งานกล้องได้ กรุณาเปิดสิทธิ์การใช้งานกล้อง */}
          {t("not_able_to_use_camera")}
        </Text>
        <TouchableOpacity
          className="bg-green-600 px-5 py-2 rounded-lg mt-3"
          onPress={requestPermission}
        >
          <Text className="text-white text-lg font-bold">
            {/* เปิดสิทธิ์การใช้งานกล้อง */}
            {t("open_camera_permission")}
          </Text>
        </TouchableOpacity>
      </View>
    );
  }

  const handleScanAgain = () => {
    setScanned(false);
    setIsCameraActive(true);
  };

  const toggleCamera = () => {
    if (cameraFacing === "front") {
      setCameraFacing("back");
    } else {
      setCameraFacing("front");
    }
  };
  return (
    <>
      <View className="flex-1 bg-[#F17736] items-center justify-center">
        <View className="w-full h-[20%] bg-[#F17736] rounded-b-[50px]"></View>
        <View className="bottom-0 w-full h-[90%] bg-white rounded-t-[20px]"></View>

        <FooterComponent />

        {/* ScrollView ครอบเนื้อหาทั้งหมด */}
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "space-between",
            padding: 20,
          }}
          showsVerticalScrollIndicator={false}
          className="absolute mt-2 top-0 w-[90%] h-[80%] px-2 bg-white rounded-2xl border border-gray-200 shadow-xl"
        >
          {/* Title */}
          <View className="w-full items-center justify-center border-b border-gray-300 pb-1">
            <Text className="text-2xl font-kanit py-2 text-gray-700">
              {/* สแกน QR Code */}
              {t("scan_qr_code")}
            </Text>
          </View>

          {/* Content */}
          <View className="w-full flex-1 py-2">
            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-lg text-gray-600 font-kanit py-1">
                {/* สแกน Qr Code ป้ายชี้บ่งผลิตภัณฑ์ */}
                {t("scan_qr_label")}
              </Text>
              <View className="flex-row items-center justify-center">
                <Text className="text-md text-red-500 font-kanit pl-2">
                  {item?.order_name}  {"(" + item?.material_code + ")"}
                </Text>
              </View>
            </View>
            <View className="w-full flex-1 items-center justify-center">
              {isCameraActive ? (
                <>
                  <CameraView
                    style={{
                      flex: 2,
                      width: "100%",
                      height: "100%",
                      borderRadius: 20,
                      borderWidth: 2,
                      borderColor: "#e0e0e0",
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 5 },
                      shadowOpacity: 0.3,
                      shadowRadius: 10,
                      overflow: "hidden",
                    }}
                    facing={cameraFacing as any}
                    barcodeScannerSettings={{ barcodeTypes: ["qr"] }}
                    onBarcodeScanned={
                      scanned ? undefined : (handleEnterlocation as any)
                    }
                  />
                  <View className="flex flex-row items-center justify-center mt-4">
                    <TouchableOpacity
                      onPress={toggleCamera}
                      className="bg-blue-500 px-4 py-2 rounded-2xl flex-row items-center mx-2"
                    >
                      <Icon name="refresh" size={14} color="#FFF" />
                      <Text className="text-white text-lg pl-2">
                        {/* เปลี่ยนกล้อง */}
                        {t("change_camera")}
                      </Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                      onPress={() => {
                        setIsCameraActive(false);
                        setTimeout(() => {
                          inputRef.current?.focus(); // ✅ ให้โฟกัสหลังจาก Modal ปิด
                        }, 300);
                      }}
                      className="bg-red-500 px-4 py-2 rounded-2xl flex-row items-center mx-2"
                    >
                      <Icon name="close" size={14} color="#FFF" />
                      <Text className="text-white text-lg pl-2">
                        {/* ปิดกล้อง */}
                        {t("close_camera")}
                      </Text>
                    </TouchableOpacity>
                  </View>
                </>
              ) : (
                <>
                  <View className="w-full items-center justify-center">
                    {/* <Icon name="qrcode" size={100} color="#1688fa" /> */}
                    <Image
                      source={require("../../assets/demo.jpg")}
                      className="w-[70%] h-[70%] rounded-xl "
                      resizeMode="contain"
                    />
                  </View>
                  <TextInput
                    ref={inputRef} // ✅ ใช้ ref เพื่อควบคุมโฟกัส
                    // placeholder="กรุณาสแกน QR Code"
                    placeholder={t("scan_qr_code")}
                    className="w-[90%] h-14 bg-gray-100 rounded-xl pl-4 mt-4 text-lg shadow-md font-kanit text-center"
                    value={inputText}
                    onChangeText={(text) => {
                      setInputText(text);
                      inputTextRef.current = text; // เก็บค่าล่าสุด
                    }}
                    showSoftInputOnFocus={false}
                    editable={true}
                    caretHidden={false}
                    onSubmitEditing={() => {
                      //   handleSubmit(inputTextRef.current); // ใช้ค่าล่าสุดที่อัปเดตทันที
                      handleEnterlocation(inputTextRef.current);
                      setInputText("");
                      inputTextRef.current = "";
                    }}
                  />

                  <Text className="text-lg text-gray-500 font-kanit py-4">
                    {/* หรือ */}
                    {t("or")}
                  </Text>
                  <View className="flex-row items-center justify-center">
                    <TouchableOpacity
                      onPress={handleScanAgain}
                      className="bg-blue-500 px-6 py-3 rounded-xl shadow-md items-center w-[90%]"
                    >
                      <View className="flex-row items-center justify-center">
                        <Icon name="camera" size={12} color="#FFF" />
                        <Text className="text-lg text-white font-kanit pl-2">
                          {/* เปิดกล้อง */}
                          {t("open_camera")}
                        </Text>
                      </View>
                    </TouchableOpacity>
                  </View>
                </>
              )}
            </View>
          </View>
        </ScrollView>
      </View>

      <Modal animationType="fade" transparent={true} visible={modalVisible}>
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            {/* Header */}
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="check-circle" size={40} color="#4CAF50" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {/* สแกนสำเร็จ */}
                {t("scan_success")}
              </Text>
            </View>

            {/* Message */}
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {modalMessage}
            </Text>

            {/* ปุ่มปิด Modal */}
            <View className="flex-row justify-center">
              <Pressable
                className="bg-blue-500 py-2 px-6 rounded-lg"
                onPress={() => {
                  //   if (modalMessage.includes("ตรงกับ")) {
                  //     setModalVisible(false);
                  //     router.push({
                  //       pathname: "/screens/selectscale",
                  //       params: { item: JSON.stringify(item) },
                  //     });
                  //   } else {
                  //     setModalVisible(false);
                  //     inputRef.current?.focus(); // ใช้ ref ในการ focus ไปที่ input
                  //   }
                  //   setInputText("");
                  //   setScanned(false);
                  //   setIsCameraActive(true);
                  setModalVisible(false);
                  router.push({
                    pathname: "/screens/retrieve",
                    params: { item: JSON.stringify(item), item2: JSON.stringify(item2) },
                  });
                  setInputText("");
                  setScanned(false);
                  setIsCameraActive(false);
                }}
              >
                <Text className="text-white text-lg font-kanit">
                  {/* ตกลง */}
                  {t("ok")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <Modal
        animationType="fade"
        transparent={true}
        visible={modalFailedVisible}
        onRequestClose={() => setModalFailedVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            {/* Header */}
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="times-circle" size={40} color="#F44336" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {/* สแกนไม่สำเร็จ */}
                {t("scan_failed")}
              </Text>
            </View>

            {/* Message */}
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {modalMessage}
            </Text>

            {/* ปุ่มปิด Modal */}
            <View className="flex-row justify-center">
              <Pressable
                className="bg-blue-500 py-2 px-6 rounded-lg"
                onPress={() => {
                  setModalFailedVisible(false);
                  setInputText("");
                  setScanned(false);
                  inputRef.current?.focus();
                }}
              >
                <Text className="text-white text-lg font-kanit">
                  {/* ตกลง */}
                  {t("ok")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <Modal
        animationType="fade"
        transparent={true}
        visible={loadingresponse}
        onRequestClose={() => setLoadingresponse(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          {/* Header */}
          <View className="flex items-center justify-center pb-3">
            <ActivityIndicator size="large" color="#F17736" />
            <Text className="text-center text-xl font-kanit text-white pl-2 pt-2">
              {/* กำลังส่งข้อมูล... */}
              {t("loading_send_data")}
            </Text>
          </View>
        </View>
      </Modal>
    </>
  );
}
